import * as React from "react"
import BaseModal  from "./base-modal"

export default class SimpleModal extends BaseModal {
	render() {
		const { children, active, onClickCloseButton, clickable = true } = this.props;

		return (
			<div className={`modal ${active ? "is-active" : ""}`}>
				<div className="modal-background" onClick={clickable ? onClickCloseButton : undefined} />
				<div className="modal-content">
					<div className="box">{children}</div>
				</div>
				<button aria-label="close" className="modal-close" onClick={onClickCloseButton} type="button" />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component/modal/simple-modal.tsx